"use strict"

import Axios from "../../../services/AxiosService"

class Service extends Axios {
  async getFieldsBySubProcess(id: number) {
    return this.request({
      method: "GET",
      url: `process-fields/${id}`,
    })
  }
}

export default () => new Service()
